<template>
    <span
        class="label"
        :class="classButton"
        >{{ capText }}</span
    >
</template>

<script>
export default {
    props: {
        value: Boolean,
    },
    data() {
        return {
            settings: {
                none: {
                    class: 'bg-gray',
                    text: 'None',
                },
                true: {
                    class: 'bg-green',
                    text: 'Yes',
                },
                false: {
                    class: 'bg-red',
                    text: 'No',
                },
            },
            classButton: '',
            capText: '',
        };
    },
    mounted() {
        this.convert();
    },
    methods: {
        convert() {
            if (this.value === null) {
                this.classButton = this.settings.none.class;
                this.capText = this.settings.none.text;
            } else if (this.value === true) {
                this.classButton = this.settings.true.class;
                this.capText = this.settings.true.text;
            } else {
                this.classButton = this.settings.false.class;
                this.capText = this.settings.false.text;
            }
        },
    },
};
</script>
